export default __webpack_public_path__ + "static/media/ico_warning_white.b3781218.svg";